
import { isNil } from "lodash";

interface SocialMediaItems {
    Name: string;
    Icon: string;
    ShareURL: string;
}
export default class SocialShare {
    shareModalElement: HTMLElement;
    socialMediaItems: SocialMediaItems[];
    pageURL: string;
    pageTitle: string;

    copyInput: HTMLInputElement;
    copyButton: HTMLButtonElement;
    buttonWrapper: HTMLDivElement;
    constructor(modalID: string, socialMediaItems: SocialMediaItems[], pageURL?: string, pageTitle?: string) {
        this.shareModalElement = document.getElementById(modalID);
        this.socialMediaItems = socialMediaItems;
        this.pageURL = pageURL;
        this.pageTitle = pageTitle;
        this.SetElements();
        this.Init();
    }
    Init() {
        this.UpdateItems()
        this.HandleCopyURL(); 
    }
    SetElements() {
        this.copyInput = this.shareModalElement.querySelector(".social-share__link input") as HTMLInputElement;
        this.copyButton = this.shareModalElement.querySelector(".copy-button") as HTMLButtonElement;
        this.buttonWrapper = this.shareModalElement.querySelector(".social-share__buttons") as HTMLDivElement;
    }
    UpdateItems() {
        this.copyInput.value = this.pageURL;
        const shareButtons = this.socialMediaItems.map(item => {
            let  shareLink = `${item.ShareURL}${this.pageURL}`;
            
            const itemLink = document.createElement('button');
            itemLink.classList.add('social-share__item');
            itemLink.setAttribute('onclick', `window.open("${shareLink}", "${item.Name}", "width=600,height=400")`);
            itemLink.innerHTML = `
                <span class="${item.Icon} social-share__icon"></span>
                <p>${item.Name}</p>
            `;
            return itemLink;
        });
        this.buttonWrapper.innerHTML = `
            ${shareButtons.map(button => button.outerHTML).join('')}
            <a class="social-share__item" href="mailto:\?Subject=${this.pageTitle}&body=${this.pageURL}">
                <span class="dot-icon dot-stroke-mail social-share__icon"></span>
                <p>Email</p>
            </a>
        `
    }
    HandleCopyURL() {
        if (!isNil(this.copyButton) && !isNil(this.copyInput)) {
            const originalValue = this.copyInput.value; // Store the original value
            this.copyButton.addEventListener('click', () => {
                this.copyInput.select();
                this.copyInput.setSelectionRange(0, 99999); // For mobile devices
                navigator.clipboard.writeText(originalValue) // Copy the original value
                    .then(() => {
                        this.copyInput.value = "Copied!";
                        setTimeout(() => {
                            this.copyInput.value = originalValue; // Restore the original value
                        }, 1500);
                    })
                .catch(error => {
                    console.error('Error copying text to clipboard:', error);
                });
            });
        }
    }
}
